export default (axios) => ({
    getDoctors: (params) => axios.get('u/doctors?origin=benhvien16a.com', { params }).then((_) => _.data),
    getMedias: (params) => axios.get('u/medias?origin=benhvien16a.com', { params }).then((_) => _.data),
    getBanners: (params) => axios.get('u/banners?origin=benhvien16a.com', { params }).then((_) => _.data),
    getFeedbacks: (params) => axios.get('u/feedbacks?createdBy=admin&origin=benhvien16a.com', { params }).then((_) => _.data),
    getMediasShowHome: (params) => axios.get('u/medias?showHome=true&origin=benhvien16a.com', { params }).then((_) => _.data),
    getSpecialist: (params) => axios.get('u/specialists?showHome=true&origin=benhvien16a.com', { params }).then((_) => _.data),
});
